(function() {
    // Function to get query parameters
    function getQueryParams() {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const params = {};
  
      urlParams.forEach((value, key) => {
        params[key] = value;
      });
  
      return params;
    }
  
    // Store query parameters in localStorage or sessionStorage
    const params = getQueryParams();
    if (Object.keys(params).length > 0) {
      sessionStorage.setItem('amazonqueryParams', JSON.stringify(params));
    }
  })();
  